









































































































import { Component, Vue } from 'vue-property-decorator';
import { Comune } from '@/data/models/comune.model';
import { Provincia } from '@/data/models/provincia.model';
import { Search } from '@/data/models/search.model';
import { ClassType } from 'class-transformer/ClassTransformer';
import store, { State } from '@/store';
import { ContattoStatus } from '@/data/models/contatto.model';

@Component
export default class ContattoFilter extends Vue {

	advancedSearch: Search;

	searchParam: any = new class {
		name?: string;
		surname?: string;
		province?: string;
		comune?: string;
		email?: string;
		telefono?: string;
		cellulare?: string;
		zipcode?: string;
		status?: string = ContattoStatus.ACTIVE;
	};

	statusItems: string[] = Object.keys(ContattoStatus).map(
		// @ts-ignore
		(k: string) => ContattoStatus[k]
	);

	provinciaClass: ClassType<Provincia> = Provincia;
	comuneClass: ClassType<Comune> = Comune;

	state!: State;

	constructor() {
		super();
		this.state = store;
		this.advancedSearch = new Search('contact');
	}

	search() {
		this.advancedSearch.reset();

		this.advancedSearch.addSimpleFilter('hqid', this.state.headquarter!.id);

		if (this.searchParam.name) this.advancedSearch.addLikeFilter('name', this.searchParam.name);
		if (this.searchParam.surname) this.advancedSearch.addLikeFilter('surname', this.searchParam.surname);
		if (this.searchParam.province && this.searchParam.province.id) this.advancedSearch.addSimpleFilter('province', this.searchParam.province.descrizione);
		if (this.searchParam.comune && this.searchParam.comune.id) this.advancedSearch.addLikeFilter('comune', this.searchParam.comune.descrizione);
		if (this.searchParam.email) this.advancedSearch.addLikeFilter('email', this.searchParam.email);
		if (this.searchParam.telefono) this.advancedSearch.addLikeFilter('landline', this.searchParam.telefono);
		if (this.searchParam.cellulare) this.advancedSearch.addLikeFilter('mobile', this.searchParam.cellulare);
		if (this.searchParam.zipcode) this.advancedSearch.addSimpleFilter('zipcode', this.searchParam.zipcode);
		if (this.searchParam.status) this.advancedSearch.addSimpleFilter('status', this.searchParam.status);

		this.$emit('search', this.advancedSearch);
	}

	reset() {
		this.searchParam.name = undefined;
		this.searchParam.surname = undefined;
		this.searchParam.zipcode = undefined;
		this.searchParam.province = {};
		this.searchParam.comune = {};
		this.searchParam.email = undefined;
		this.searchParam.telefono = undefined;
		this.searchParam.cellulare = undefined;
		this.searchParam.status = ContattoStatus.ACTIVE;
		this.search();
	}

}
